import { init } from '../email-link-init';

window.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.obfuscated-email').forEach((element: HTMLElement) => {
    init(element);
  });
});
